import { useState } from 'react';
import { IconWhatsup, IconPhoneCall11, IconEmailsLetterMail } from '@creditas-ui/icons';
import navigateToUrl from '../../shared/utilities/navigateToUrl';
import { CREDITAS_EMAIL, CREDITAS_PHONE_NUMBER, CREDITAS_WHATSAPP } from '../components/HelpModal/helpModal.constants';

const contactList = [
  {
    icon: IconWhatsup,
    name: 'Whatsapp',
    url: CREDITAS_WHATSAPP,
  },
  {
    icon: IconPhoneCall11,
    name: 'Teléfono',
    url: `tel:${CREDITAS_PHONE_NUMBER}`,
  },
  {
    icon: IconEmailsLetterMail,
    name: 'Email',
    url: CREDITAS_EMAIL,
  },
];

export const useHeader = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleContactRedirect = (url: string): void => {
    navigateToUrl(url, '_blank');
  };

  const toggleModal = () => setIsOpen(!isOpen);

  return {
    contactList,
    isOpen,
    handleContactRedirect,
    toggleModal,
  };
};
